function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", {
  fill: "#004152",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M5.423 18.023C2.43 18.023 0 15.616 0 12.644c0-2.972 2.43-5.38 5.423-5.38 2.994 0 5.424 2.408 5.424 5.38s-2.43 5.38-5.424 5.38zm0-1.442c2.2 0 3.982-1.764 3.982-3.937S7.624 8.707 5.423 8.707c-2.2 0-3.981 1.764-3.981 3.937s1.78 3.937 3.981 3.937zM25.577 18.023c-2.994 0-5.424-2.407-5.424-5.379 0-2.972 2.43-5.38 5.424-5.38 2.993 0 5.423 2.408 5.423 5.38s-2.43 5.38-5.423 5.38zm0-1.442c2.2 0 3.981-1.764 3.981-3.937s-1.78-3.937-3.981-3.937c-2.2 0-3.982 1.764-3.982 3.937s1.781 3.937 3.982 3.937z"
}), React.createElement("rect", {
  width: 9.405,
  height: 1.331,
  x: 4.752,
  y: 11.979,
  rx: 0.665
}), React.createElement("path", {
  d: "M8.782 6.655c-1.343-.444-6.718-.888-6.718-.888V3.993s5.375.443 7.614 1.33c1.343 1.332 3.135 1.332 3.135 1.332s1.343-2.662 2.687-2.662h5.374s2.707-.464 3.583-1.331c.876-.867-.448-2.662.896-2.218 1.343.443 2.239 3.549 2.239 3.549v2.662s-6.718-1.331-8.061 2.662c-1.344 3.992 0 6.654 0 6.654h-8.062s1.344-3.992 0-6.654c0-.444-1.343-2.219-2.687-2.662z"
}), React.createElement("path", {
  d: "M26.205 12.291l-3.358-5.989a.72.72 0 0 0-1.258.705l3.359 5.99a.72.72 0 1 0 1.257-.706z"
}));

var SvgVehicleMotorcycle = function SvgVehicleMotorcycle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 31,
    height: 18,
    viewBox: "0 0 31 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVehicleMotorcycle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle-motorcycle.a80136a3.svg";
export { ForwardRef as ReactComponent };